(function() {
  var CONFIG = window.OLFONG_ROUNDUP_CONFIG || {};
  var DONATION_VARIANT_ID = parseInt(CONFIG.variantId, 10);
  var DONATION_UNIT_PRICE = CONFIG.unitPrice || 10;

  if (!DONATION_VARIANT_ID) {
    console.warn('[donate] No donation variant ID configured');
    return;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
  }

  function findDonationItem(cart) {
    return cart.items.find(function(item) { return item.variant_id === DONATION_VARIANT_ID; });
  }

  // Set the donation line to exactly `amountKr` (0 removes it).
  function setDonation(amountKr) {
    var qty = Math.round(amountKr / DONATION_UNIT_PRICE);
    return fetchCart().then(function(cart) {
      var existing = findDonationItem(cart);
      if (qty === 0) {
        if (!existing) return Promise.resolve();
        return post('/cart/change.js', { id: existing.key, quantity: 0 });
      }
      if (existing) {
        if (existing.quantity === qty) return Promise.resolve();
        return post('/cart/change.js', { id: existing.key, quantity: qty });
      }
      return post('/cart/add.js', { id: DONATION_VARIANT_ID, quantity: qty });
    });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  // Tell the theme to refresh the cart (items, totals, icon) via its fast Section
  // Rendering — NOT by fetching the whole homepage. Suppress drawer auto-open.
  function notifyCart(cart) {
    var drawers = document.querySelectorAll('cart-drawer-component[auto-open]');
    drawers.forEach(function(d) { d.removeAttribute('auto-open'); });
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'donation', data: { source: 'donation', itemCount: cart.item_count } }
    }));
    drawers.forEach(function(d) { d.setAttribute('auto-open', ''); });
  }

  // Pick an amount from the dropdown: set that donation (0 = remove).
  document.addEventListener('change', function(e) {
    var sel = e.target.closest('[data-olfong-donate-select]');
    if (!sel) return;
    var widget = sel.closest('[data-olfong-roundup]');
    if (!widget) return;
    if (widget.classList.contains('is-loading')) return;

    var amount = parseInt(sel.value, 10) || 0;
    widget.classList.add('is-loading');

    setDonation(amount)
      .then(fetchCart)
      .then(function(cart) {
        notifyCart(cart);
        updateUI();
        // The theme re-renders (morphs) the cart section on cart:update, which
        // resets the dropdown — re-apply the chosen amount once that settles.
        setTimeout(updateUI, 400);
        setTimeout(updateUI, 900);
        widget.classList.remove('is-loading');
      })
      .catch(function(err) {
        console.error('[donate] update error:', err);
        widget.classList.remove('is-loading');
      });
  }, true);

  function applyCart(cart) {
    var widgets = document.querySelectorAll('[data-olfong-roundup]');
    if (!widgets.length) return;
    var existing = findDonationItem(cart);
    var donationKr = existing ? existing.line_price / 100 : 0;
    widgets.forEach(function(widget) {
      widget.classList.toggle('is-active', donationKr > 0);
      // Keep the dropdown on the chosen amount (or "Veldu upphæð…" if none).
      var sel = widget.querySelector('[data-olfong-donate-select]');
      if (sel) sel.value = String(Math.round(donationKr));
    });
  }
  function updateUI(e) {
    if (!document.querySelectorAll('[data-olfong-roundup]').length) return;
    // On cart:update, reuse the cart the event carries instead of another /cart.js fetch.
    var carried = e && e.detail && e.detail.resource;
    if (carried && carried.items) { applyCart(carried); return; }
    fetchCart().then(applyCart).catch(function(err) { console.error('[donate] updateUI error:', err); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateUI);
  } else {
    updateUI();
  }

  ['cart:update', 'cart:updated', 'cart-drawer:opened', 'cart-items:update', 'cart:refresh'].forEach(function(evt) {
    document.addEventListener(evt, updateUI);
  });

  var obsPending = false;
  var observer = new MutationObserver(function(mutations) {
    if (obsPending) return; // skip work during a burst until the rAF pass runs
    var found = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if ((node.matches && node.matches('[data-olfong-roundup]')) ||
            (node.querySelector && node.querySelector('[data-olfong-roundup]'))) found = true;
      });
    });
    if (!found) return;
    obsPending = true;
    requestAnimationFrame(function() { obsPending = false; updateUI(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
